import type { HTMLAttributes, ReactElement } from 'react';

import { cn } from '../lib/cn';

export interface SkeletonShimmerProps extends HTMLAttributes<HTMLDivElement> {
  /** Largura customizada via Tailwind (ex: 'w-24', 'w-full') */
  width?: string;
  /** Altura customizada via Tailwind (ex: 'h-4', 'h-32') */
  height?: string;
  /** Border radius (default: rounded-lg) */
  radius?: string;
}

export function SkeletonShimmer({
  className,
  width = 'w-full',
  height = 'h-4',
  radius = 'rounded-lg',
  ...rest
}: SkeletonShimmerProps): ReactElement {
  return (
    <div
      aria-hidden
      className={cn(width, height, radius, 'trakd-skeleton-shimmer', className)}
      {...rest}
    />
  );
}
